import styled from '@emotion/styled';
import React from 'react';
import MuiFormControl, { FormControlProps } from '@mui/material/FormControl';
import { formHelperTextClasses } from '@mui/material/FormHelperText';

const StyledFormControl = styled(MuiFormControl)<FormControlProps>`
    & .${formHelperTextClasses.root} {
        font-size: 12px;
        color: ${(props) => props.theme.colorsUnifications.watermelon['100']};
    }
`;

export const FormControl = React.forwardRef<HTMLDivElement | null, FormControlProps>(
    ({ children, ...props }, ref) => {
        return (
            <StyledFormControl variant="standard" {...props} ref={ref}>
                {children}
            </StyledFormControl>
        );
    },
);
